(function () {
  'use strict';

  // ── helpers ──────────────────────────────────────────────────────────────

  function moneyFormat(bani) {
    return (bani / 100).toFixed(2).replace('.', ',') + ' RON';
  }

  // ── dynamic container injection ───────────────────────────────────────────
  // Called when #cart-cross-sell-container is missing from the DOM.
  // This happens when the cart was empty at page load so Liquid skipped the
  // block — we recreate it in JS using product_id from /cart.js.

  var injecting = false; // guard against concurrent injections

  function injectCrossSellContainer(callback) {
    if (document.getElementById('cart-cross-sell-container')) {
      if (callback) callback();
      return;
    }
    if (injecting) return;

    // Only inject when the drawer is in its non-empty state
    var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    if (!drawerInner) return;
    var drawerFooter = drawerInner.querySelector('.drawer__footer');
    if (!drawerFooter) return;

    injecting = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        injecting = false;
        if (!cart.items || !cart.items.length) return;

        var productId = cart.items[0].product_id;

        var wrapper = document.createElement('div');
        wrapper.className = 'cart-cross-sell';
        wrapper.innerHTML =
          '<p class="cart-cross-sell__title">S-ar putea sa-ti placa si</p>' +
          '<div class="cart-cross-sell__list" id="cart-cross-sell-container"' +
          ' data-product-id="' + productId + '"></div>';

        drawerInner.insertBefore(wrapper, drawerFooter);

        if (callback) callback();
      })
      .catch(function () { injecting = false; });
  }

  // ── cross-sell init ───────────────────────────────────────────────────────

  function initCrossSell() {
    var container = document.getElementById('cart-cross-sell-container');

    if (!container) {
      // Container absent — Liquid skipped it (empty cart at page load).
      // Inject dynamically then re-run.
      injectCrossSellContainer(function () {
        initCrossSell();
      });
      return;
    }

    if (container.dataset.loaded) return;
    container.dataset.loaded = '1';

    var productId = container.dataset.productId;
    if (!productId) return;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Re-query from DOM — the closure reference may be stale if the drawer
        // re-rendered between the fetch starting and the response arriving.
        container = document.getElementById('cart-cross-sell-container');
        if (!container) return;

        var products = data.products || [];
        if (!products.length) {
          var wrap = container.closest('.cart-cross-sell');
          if (wrap) wrap.style.display = 'none';
          return;
        }

        container.innerHTML = products.map(function (p) {
          var v = p.variants[0];
          // ATENTIE: in Ajax API (`/recommendations/products.json`) `images` e un
          // tablou de STRING-uri cu URL-uri, nu de obiecte. `p.images[0].src` da
          // undefined, iar `.replace` pe undefined arunca TypeError — care era
          // inghitit de `.catch`-ul de mai jos si ascundea tot blocul, fara nimic
          // in consola. De asta cross-sell-ul nu a mers niciodata.
          var imgSrc = p.images && p.images.length
            ? String(p.images[0]).replace(/\.(jpg|jpeg|png|webp|gif)(\?|$)/, '_100x100.$1$2')
            : '';
          // Card orizontal compact, nu vertical: pe mobil recomandarile ocupau
          // 265px, de doua ori cat produsele din cos. Poza 56px, nume pe un rand,
          // pret sub el, buton "+" in dreapta.
          return '<div class="cart-cross-sell__item">' +
            (imgSrc
              ? '<img class="cart-cross-sell__img" src="' + imgSrc + '" alt="" width="56" height="56" loading="lazy">'
              : '<div class="cart-cross-sell__img"></div>') +
            '<div class="cart-cross-sell__info">' +
            '<span class="cart-cross-sell__name">' + p.title + '</span>' +
            '<span class="cart-cross-sell__price">' + moneyFormat(v.price) + '</span>' +
            '</div>' +
            '<button class="cart-cross-sell__add" data-variant-id="' + v.id +
            '" aria-label="Adauga in cos">+</button>' +
            '</div>';
        }).join('');

        container.querySelectorAll('.cart-cross-sell__add').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            btn.disabled = true;
            btn.textContent = '...';

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: parseInt(btn.dataset.variantId, 10), quantity: 1 })
            })
              .then(function (r) {
                if (!r.ok) throw new Error('add failed');
                btn.textContent = '✓';
                // Refresh the drawer so totals, free-shipping bar, and bubble update.
                return fetch('/?sections=cart-drawer', {
                  headers: { 'X-Requested-With': 'XMLHttpRequest' }
                });
              })
              .then(function (r) { return r.json(); })
              .then(function (sectionsData) {
                var html = sectionsData['cart-drawer'];
                if (!html) return;
                var doc = new DOMParser().parseFromString(html, 'text/html');

                // Replace drawer inner — the .drawer__inner MutationObserver fires
                // and calls initCrossSell() on the new empty container.
                var newInner = doc.querySelector('.drawer__inner');
                var oldInner = document.querySelector('#CartDrawer .drawer__inner');
                if (newInner && oldInner) {
                  oldInner.innerHTML = newInner.innerHTML;
                }

                // Update count bubble in header
                var newBubble = doc.querySelector('.cart-count-bubble');
                var oldBubble = document.querySelector('.cart-count-bubble');
                if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
              })
              .catch(function () {
                btn.disabled = false;
                btn.textContent = '+';
              });
          });
        });
      })
      .catch(function () {
        var wrap = container.closest('.cart-cross-sell');
        if (wrap) wrap.style.display = 'none';
      });
  }

  // ── observers ─────────────────────────────────────────────────────────────

  // Holds the observer for the current .drawer__inner element.
  // Must be re-created whenever renderContents() destroys and recreates it.
  var drawerInnerObserver = null;

  function attachDrawerInnerObserver() {
    if (drawerInnerObserver) drawerInnerObserver.disconnect();

    var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    if (!drawerInner) return;

    drawerInnerObserver = new MutationObserver(function () {
      // Fired when updateQuantity() or onCartUpdate() replaces .drawer__inner
      // children. Give DOM 200 ms to settle.
      setTimeout(initCrossSell, 200);
    });
    drawerInnerObserver.observe(drawerInner, { childList: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Cover the case where cart already has items at page load.
    initCrossSell();
    attachDrawerInnerObserver();

    // Watch #CartDrawer (permanent, never replaced — only its innerHTML is
    // swapped by renderContents()).  When its direct children change, a new
    // .drawer__inner has been created and we must re-attach + re-init.
    var cartDrawerEl = document.getElementById('CartDrawer');
    if (cartDrawerEl) {
      new MutationObserver(function () {
        // renderContents() just swapped #CartDrawer.innerHTML.
        // Wait 200 ms then re-attach observer and init cross-sell.
        setTimeout(function () {
          attachDrawerInnerObserver();
          initCrossSell();
        }, 200);
      }).observe(cartDrawerEl, { childList: true });
    }
  });
})();
